<template lang="html">
  <div class="dashboard grid-container">
    <div class="dashboard-header">
      <sl-switcher></sl-switcher>

      <div class="sl-btn-list" >
        <router-link @click.native="$ga.event('Link', '+ Create New Coupon', 'Dashboard')" tag="el-button" class="sl-el-btn sl-btn-green" :to="{ name: 'Choose-Coupon'}" v-if="$store.state.user.userinfo.roleId === '2' ">+ {{$t('Views.Coupons.CNC')}}</router-link>
      </div>
    </div>

    <div class="dashboard-stats">
      <sl-show-box :data="box"></sl-show-box>
    </div>

    <el-card class="dashboard-chart" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <span class="sl-name">{{$t('Chart.revenue')}} ({{$store.state.theme.companyInfo.currency}})</span>
      </div>
      <div class="sl-body">
        <chart :options="revenueConfig.default" ref="revenue" auto-resize theme="default" v-loading="rLoading"></chart>
      </div>
    </el-card>
    <el-card class="dashboard-chart" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <span class="sl-name">{{$t('Chart.numberOfOrder')}}</span>
      </div>
      <div class="sl-body">
        <chart :options="orderConfig.default" ref="order" auto-resize theme="default" v-loading="nooLoading"></chart>
      </div>
    </el-card>
    <div class="sl-mask" v-show="newUser">
      <div class="sl-block-welcome">
        <p class="sl-title">{{$t('Views.Dashboard.welTitle')}}</p>
        <p class="sl-cnt">{{$t('Views.Dashboard.welCnt')}}</p>
        <div class="sl-btn" @click="goDashboard">{{$store.state.theme.companyInfo.welcome}}</div>
      </div>
    </div>

  </div>
  </template>

  <script>
  import api from '../api'
  import * as config from '../util/echart-config'
  export default {
    name: 'dashboard',
    data() {
      return {
        rLoading: false,
        nooLoading: false,
        arpcConfig: config.bar,
        revenueRadio: 'op1',
        revenueConfig: {
          default: config.line,
          hour: {},
          week: {},
          month: {},
          year: {}
        },
        orderRadio: 'op1',
        orderConfig: {
          default: config.line,
          hour: {},
          week: {},
          month: {},
          year: {}
        },
        box: []
      }
    },
    computed: {
      switcher() {
        return this.$store.state.switcher.activeTime
      },
      newUser() {
        return this.$route.query.new === '1' ? true : !true
      }
    },
    created() {
      const vm = this
      this.rLoading = true
      this.nooLoading = true
      api.FetchDashboardBox().then(res => {
        vm.box = res.data.data
      })
      api.FetchDashboardChart3().then(res => {
        const result = res.data.data
        vm.revenueConfig.hour = result.hour
        vm.revenueConfig.week = result.week
        vm.revenueConfig.month = result.month
        vm.revenueConfig.year = result.year
        vm.resetRevenueOp('hour')
        vm.rLoading = false
      })
      api.FetchDashboardChart4().then(res => {
        const result = res.data.data
        vm.orderConfig.hour = result.hour
        vm.orderConfig.week = result.week
        vm.orderConfig.month = result.month
        vm.orderConfig.year = result.year
        vm.resetOrderOp('hour')
        vm.nooLoading = false
      })
    },
    watch: {
      switcher(params) {
        this.resetRevenueOp(params, this.$t('Chart.revenue'))
        this.resetOrderOp(params, this.$t('Chart.revenue'))
        this.reRenderBox(params)
      }
    },
    methods: {
      reRenderBox(params) {
        const vm = this
        this.box = []
        api.FetchDashboardBox({
          dateRange: params
        }).then(res => {
          vm.box = res.data.data
        })
      },
      goDashboard() {
        this.$router.replace({
          name: 'Dashboard'
        })
      },
      resetRevenueOp(params, name) {
        this.$refs.revenue.mergeOptions({
          tooltip: {
            formatter: '{b}<br/>Revenue : ' + this.$store.state.theme.companyInfo.currency + '{c}'
          },
          xAxis: [
            {
              data: this.revenueConfig[params].xAxis
            }
          ],
          series: [
            {
              name: name,
              data: this.revenueConfig[params].yAxis
            }
          ]
        })
      },
      resetOrderOp(params, name) {
        this.$refs.order.mergeOptions({
          tooltip: {
            formatter: '{b}<br/>Number of orders : {c}'
          },
          xAxis: [
            {
              data: this.orderConfig[params].xAxis
            }
          ],
          series: [
            {
              name: name,
              data: this.orderConfig[params].yAxis
            }
          ]
        })
      }
    }
  }
  </script>

  <style scoped>
  .dashboard .sl-body {
    height: 290px;
  }

  .sl-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.7);
    box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    overflow-y: hidden;
  }

  .sl-block-welcome {
    width: 460px;
    height: 300px;
    background: #ffffff;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -230px;
    margin-top: -150px;
    text-align: center;
  }

  .sl-title {
    font-family: Avenir-Medium;
    font-size: 24px;
    color: #4a4a4a;
    line-height: 32px;
    padding-top: 48px;
    text-align: center;
  }

  .sl-cnt {
    max-width: 350px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    top: 12px;
  }

  .sl-btn {
    font-family: Avenir-Medium;
    font-size: 14px;
    color: #ffffff;
    background: #2b90e9;
    border-radius: 2px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    margin: 40px auto 0;
    cursor: pointer;
    display: inline-block;
    padding: 0 15px;
  }

  .dashboard-header {
    padding: 20px 16px 16px;
    margin-bottom: 12px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }


  .dashboard-stats {
    padding: 16px;
  }


  .dashboard-chart {
    margin-bottom: 32px;
    margin: 16px;
  }

  .dashboard-chart .echarts {
    width: 100%;
  }

  @media screen and (max-width: 640px) {
    .dashboard-header {
      flex-direction: column;
    }
    .sl-btn-list {
      width: 100%;
    }
    .sl-btn-list .sl-el-btn {
      width: 100%;
    }
  }
  </style>



// WEBPACK FOOTER //
// dashboard.vue?dd314668